import { axios } from '@Root/API'

export const deleteInit = id => {
  return axios.delete(`locked-forms/${id}`)
}
